import React from "react";

const Button = ({ content, onClick, active, disabled }) => {
    return (
        <button
        className={`flex flex-col cursor-pointer items-center justify-center w-9 h-9 shadow-[0_4px_10px_rgba(0,0,0,0.03)] text-sm font-bold transition-colors rounded-lg
            ${active ? "bg-gray-300 text-green-600" : "text-gray-600"}
            ${
              !disabled
                ? "bg-white hover:bg-gray-500 hover:text-white"
                : "text-gray-400 bg-white cursor-not-allowed"
            }
            `}
        onClick={onClick}
        disabled={disabled}
      >
        {content}
      </button>
    );
};

export default Button;
